<template>
	<div _bg="white" _p="20px">
		<div class="ability-detail-header" @click="$router.go(-1)">
			<i class="el-icon-arrow-left" style="margin-right: 5px;font-weight: 1000;"></i>返回
		</div>
		<div _border="1px solid [#ECECEC]">
			<div _text="18px" class="font-bold" _bg="[#ECECEC]" _p="x-25px y-15px">个人信息</div>
			<div _p="25px">
				<div _flex="~ items-center">
					<div _w="80px">头像</div>
					<img :src="info.avatar?.url || 'https://file.xinhuomy.com/default.png'" width="80px" height="80px" _border="rounded-[1100px]" />
					<el-button
						icon="el-icon-edit-outline"
						size="small"
						style="margin-left: 20px;"
						@click="
							;(editPersonVisible = true), (personParams = cloneDeep(info)), (editVisibleType = editType.info.type)
						"
						>编辑</el-button
					>
				</div>
				<div _flex="~ items-center" _m="t-30px">
					<div _w="80px">账号</div>
          <el-input v-model="info.login_name" class="width-300" size="small" disabled></el-input>
          <el-button
						type="text"
						@click=";(editPersonVisible = true), (personParams = cloneDeep(info)), (editVisibleType = editType.login.type)"
						size="small"
						style="margin-left: 20px;"
            v-if="
              $store.state.user.userInfo.type === $api.account.types.TEACHER.value ||
              $store.state.user.userInfo.type === $api.account.types.SCHOOL_ADMIN.value
            "
					>更换</el-button>
				</div>
				<div _flex="~ items-center" _m="t-30px">
					<div _w="80px">姓名</div>
					<el-input v-model="info.realname" class="width-300" size="small" disabled></el-input>
				</div>
				<div _flex="~ items-center" _m="t-30px">
					<div _w="80px">性别</div>
					<el-input
						:value="sex.find(item => item.val == info.sex)?.name || '未知'"
						placeholder="女"
						class="width-300"
						size="small"
						disabled
					></el-input>
				</div>
				<div _flex="~ items-center" _m="t-30px">
					<div _w="80px">手机号码</div>
					<el-input
						maxlength="11"
						:value="phone(info.mobile)"
						placeholder="未绑定"
						class="width-300"
						size="small"
						disabled
					></el-input>
					<el-button
						type="text"
						@click="
							info.mobile ? (identityVisible = true) : (editPersonVisible = true),
								(editVisibleType = editType.phone.type)
						"
						size="small"
						style="margin-left: 20px;"
						>{{ info.mobile ? '更换' : '去绑定' }}</el-button
					>
				</div>
				<div _flex="~ items-center" _m="t-30px">
					<div _w="80px">密码</div>
					<el-input placeholder="已设置，可通过账号密码登录" class="width-300" size="small" disabled></el-input>
					<el-button
						type="text"
						@click=";(editPersonVisible = true), (editVisibleType = editType.pass.type)"
						size="small"
						style="margin-left: 20px;"
						>更换</el-button
					>
				</div>
			</div>
		</div>
		<el-dialog
			class="scope-dialog"
			:width="'540px'"
			:before-close="beforeClose"
			:close-on-click-modal="false"
			:visible="editPersonVisible"
			@close="beforeClose"
			:title="editType[editVisibleType]?.title"
		>
			<el-divider></el-divider>
      <el-form
				:ref="'login'"
				:rules="editType.login.rules"
				:model="personParams"
				v-show="editVisibleType == editType.login?.type"
        style="max-height:100px"
			>
				<el-form-item label="账号" prop="login_name" label-width="80px">
          <InputTopTip v-model="personParams.login_name" :placeholder="'账号'" >
            <el-input
              v-model="personParams.login_name"
              oninput="value=value.trim()"
              size="small"
              minlength="3"
              maxlength="15"
              style="width: 300px;"
              placeholder=""
            ></el-input>
          </InputTopTip>
				</el-form-item>
			</el-form>
			<el-form
				:ref="'info'"
				:rules="editType.info.rules"
				:model="personParams"
				v-show="editVisibleType == editType.info?.type"
			>
				<el-form-item label="头像" label-width="80px">
					<div _flex="~" _p="t-20px">
						<img
							:src="personParams.avatar?.url || personParams.avatar?.uri"
							width="60px"
							height="60px"
							_border="rounded-[1100px]"
						/>
						<div _m="l-20px" _flex="~ col justify-end">
							<el-button size="small" style="width: 100px;" @click="fileUpload">点击上传</el-button>
							<span _text="[#dcdfe6]">只能上传jpg/png文件，且不超过5MB</span>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="姓名" label-width="80px">
          <InputTopTip v-model="personParams.realname" :placeholder="'姓名'" >
            <el-input
              v-model="personParams.realname"
              oninput="value=value.trim()"
              size="small"
              style="width: 300px;"
              placeholder=""
            ></el-input>
          </InputTopTip>
				</el-form-item>
				<el-form-item label="性别" label-width="80px">
          <InputTopTip v-model="personParams.sex" :placeholder="'性别'" >
            <el-select
              ref="SearchClass"
              style="width: 300px;"
              v-model="personParams.sex"
              placeholder=""
              size="small"
            >
              <el-option v-for="item in sex" :key="item.val" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </InputTopTip>
				</el-form-item>
			</el-form>
			<el-form
				:ref="'phone'"
				:rules="editType.phone.rules"
				:model="phoneParams"
				v-show="editVisibleType == editType.phone?.type"
				@validate="validateCallback"
				label-position="left"
			>
				<el-form-item v-if="info.mobile">
					<div _text="[#747474] 16px" style="line-height: 30px;">
						当前账号已绑定手机号码：{{ phone(info.mobile) }}更换后，下次可以使用新手机号码登录
					</div>
				</el-form-item>
				<el-form-item label="手机号码" prop="phone" label-width="80px">
          <InputTopTip v-model="phoneParams.phone" :placeholder="'手机号码'" style="width: 270px; margin-right: 20px; display: inline-block">
            <el-input
              v-model="phoneParams.phone"
              oninput="value=value.trim()"
              size="small"
              placeholder=""
              maxlength="11"
            ></el-input>
          </InputTopTip>
					<el-button
						style="width: 100px;"
						type="primary"
						size="small"
						:disabled="!codeVisible"
						@click="getPhoneCode"
						v-if="!codeLoad"
						>{{ '获取验证码' }}</el-button
					>
					<el-button style="width: 100px;" type="primary" size="small" :disabled="true" @click="getPhoneCode" v-else>{{
						`${time}s`
					}}</el-button>
				</el-form-item>
				<el-form-item label="验证码" prop="code" label-width="80px">
          <InputTopTip v-model="phoneParams.code" :placeholder="'验证码'" >
            <el-input
              v-model="phoneParams.code"
              oninput="value=value.trim()"
              size="small"
              style="width: 270px;"
              placeholder=""
              maxlength="6"
            ></el-input>
          </InputTopTip>
				</el-form-item>
			</el-form>
			<el-form :ref="'pass'" :model="passParams" v-show="editVisibleType == editType.pass?.type">
				<el-form-item label="原密码" prop="pass_old" label-width="80px" :rules="editType.pass.rules.pass_old">
          <InputTopTip v-model="passParams.pass_old" :placeholder="'原密码'" >
            <el-input
              v-model="passParams.pass_old"
              :type="!passOldVisible ? 'password' : 'text'"
              oninput="value=value.trim()"
              size="small"
              style="width: 300px;"
              placeholder=""
            >
              <img
                slot="suffix"
                :src="require('@/assets/image/eyes.png')"
                width="14px"
                height="16px"
                _opacity="[0.7]"
                _cursor="pointer"
                v-if="passOldVisible"
                @click="passOldVisible = false"
              />
              <img
                slot="suffix"
                :src="require('@/assets/image/eyes-mask.png')"
                width="14px"
                height="16px"
                _opacity="[0.7]"
                _cursor="pointer"
                v-else
                @click="passOldVisible = true"
              />
            </el-input>
          </InputTopTip>
				</el-form-item>
				<el-form-item label="新密码" prop="pass1" label-width="80px" :rules="editType.pass.rules.pass1">
          <InputTopTip v-model="passParams.pass1" :placeholder="'新密码'" >
            <el-input
              v-model="passParams.pass1"
              :type="!pass1Visible ? 'password' : 'text'"
              oninput="value=value.trim()"
              size="small"
              style="width: 300px;"
              placeholder=""
            >
              <img
                slot="suffix"
                :src="require('@/assets/image/eyes.png')"
                width="14px"
                height="16px"
                _opacity="[0.7]"
                _cursor="pointer"
                v-if="pass1Visible"
                @click="pass1Visible = false"
              />
              <img
                slot="suffix"
                :src="require('@/assets/image/eyes-mask.png')"
                width="14px"
                height="16px"
                _opacity="[0.7]"
                _cursor="pointer"
                v-else
                @click="pass1Visible = true"
              />
            </el-input>
          </InputTopTip>
				</el-form-item>
				<el-form-item
					label="确认密码"
					prop="pass2"
					label-width="80px"
					:rules="[
						...editType.pass.rules.pass1,
						{ required: true, validator: samePassCheck, trigger: ['blur', 'change'] }
					]"
				>
          <InputTopTip v-model="passParams.pass2" :placeholder="'新密码'" >
            <el-input
              :type="!pass2Visible ? 'password' : 'text'"
              v-model="passParams.pass2"
              oninput="value=value.trim()"
              size="small"
              style="width: 300px;"
              placeholder=""
            >
              <img
                slot="suffix"
                :src="require('@/assets/image/eyes.png')"
                width="14px"
                height="16px"
                _opacity="[0.7]"
                v-if="pass2Visible"
                _cursor="pointer"
                @click="pass2Visible = false"
              />
              <img
                slot="suffix"
                :src="require('@/assets/image/eyes-mask.png')"
                width="14px"
                height="16px"
                _opacity="[0.7]"
                _cursor="pointer"
                v-else
                @click="pass2Visible = true"
              />
            </el-input>
          </InputTopTip>
				</el-form-item>
			</el-form>
			<el-divider _m="t-40px"></el-divider>
			<div style="margin-top: 20px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;">
				<el-button
					class="btn-close"
					@click="editPersonVisible = false"
					style="width: 80px; height: 32px; line-height: 1px;"
					>取 消</el-button
				>
				<el-button
					class="btn-prim"
					type="primary"
					style="width: 80px; height: 32px; line-height: 1px;"
					@click="boxConfirmEvent(editType[editVisibleType].type)"
					>确定</el-button
				>
			</div>
		</el-dialog>

		<el-dialog
			class="scope-dialog"
			:width="'540px'"
			:close-on-click-modal="false"
			:visible="identityVisible"
			:title="'身份验证'"
			:before-close="identityBeforeClose"
			@close="identityBeforeClose"
		>
			<el-divider></el-divider>
			<el-form :model="identityParams" ref="identityForm">
				<el-form-item>
					<div _text="[#747474] 16px" style="line-height: 30px;">
						为了保护你的账户安全，请验证身份，验证成功进行下一步操作
					</div>
				</el-form-item>
				<el-form-item>
					<div _text="[#747474] 16px" style="line-height: 30px;">
						{{ `使用手机 ${phone(info.mobile)} 验证` }}
					</div>
				</el-form-item>
				<el-form-item label="验证码" prop="code" :rules="editType.phone.rules.code" label-width="70px">
          <InputTopTip v-model="identityParams.code" :placeholder="'验证码'" style="width: 270px; margin-right: 15px;display: inline-block">
            <el-input
              v-model="identityParams.code"
              oninput="value=value.trim()"
              size="small"
              placeholder=""
              maxlength="6"
            ></el-input>
          </InputTopTip>
					<el-button style="width: 100px;" type="primary" size="small" @click="oldPhoneCode" v-if="!codeLoad">{{
						'获取验证码'
					}}</el-button>
					<el-button style="width: 100px;" type="primary" size="small" :disabled="true" v-else>{{
						`${time}s`
					}}</el-button>
				</el-form-item>
			</el-form>
			<el-divider></el-divider>
			<div style="margin-top: 20px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;">
				<el-button
					class="btn-close"
					@click="identityVisible = false"
					style="width: 80px; height: 32px; line-height: 1px;"
					>取 消</el-button
				>
				<el-button
					class="btn-prim"
					type="primary"
					style="width: 80px; height: 32px; line-height: 1px;"
					@click="oldPhoneVerify"
					:disabled="identityParams.code.length != 6"
					>验证</el-button
				>
			</div>
		</el-dialog>
    <CodeTest v-model="code.visible" :confirm="code.event" />
	</div>
</template>
<script>
import { editType, sex } from './const.js'
import { uploadFileEvent } from './upload.js'
import { cloneDeep } from 'lodash'
import CodeTest from '@/components/CodeTest.vue'
export default {
  components: { CodeTest }, //微信扫码登录
	data() {
		return {
      code: {
        event: null,
        visible: false, // 图形验证码显示
      },
			editVisibleType: '',
			editType,
			sex,
			editPersonVisible: false,
			identityVisible: false,
			codeVisible: false,
			codeLoad: false,
			pass1Visible: false,
			pass2Visible: false,
			passOldVisible: false,
			time: 60,
			info: {},
			personParams: { realname: '', sex: '', avatar: {}, login_name: '' },
			phoneParams: { phone: '', code: '' },
			passParams: { pass_old: '', pass1: '', pass2: '' },
			identityParams: { code: '' }
		}
	},
	mounted() {
		const userInfo = this.$store.state.user.userInfo
		this.info = userInfo
	},
	methods: {
		samePassCheck(rule, value, callback) {
			if (value) {
				if (value == this.passParams.pass1) {
					callback() // 校验通过
				} else {
					callback(new Error('两次输入的密码不一致'))
				}
			} else {
				callback(new Error('密码应包含字母、数字、特殊符号，且限制长度在8到16位')) // 校验失败，返回错误信息
			}
		},
		phone(tel) {
			if (tel) {
				return tel?.substring(0, 3) + '****' + tel?.substr(tel.length - 4)
			} else {
				return ''
			}
		},
		validateCallback(type, event) {
			console.log(type, event)
			if (type == 'phone') {
				if (this.phoneParams.phone == this.info.mobile) {
					this.$message.error('新手机不能与旧手机号相同')
					this.codeVisible = false
				} else {
					this.codeVisible = event
				}
			}
		},

		cloneDeep,
		beforeClose() {
			if (this.editVisibleType == 'phone') {
				this.codeVisible = false
				clearInterval(this.timer)
				this.time = 60
				this.codeLoad = false
			}
			this.$refs[this.editType[this.editVisibleType].type].resetFields()
			this.editPersonVisible = false
		},
		identityBeforeClose() {
			this.codeVisible = false
			clearInterval(this.timer)
			this.time = 60
			this.codeLoad = false
			this.$refs.identityForm.resetFields()
			this.identityVisible = false
		},
		boxConfirmEvent(refName) {
			this.$refs[refName].validate(async valid => {
				if (valid) {
					if (this.editVisibleType == 'phone') {
						if (this.info.mobile) {
							await this[this.editType[this.editVisibleType]['method']]()
						} else {
							await this.firstPhoneBind()
						}
					} else {
						await this[this.editType[this.editVisibleType]['method']]()
					}
					this.beforeClose()
				} else {
					return false
				}
			})
		},
		async firstPhoneBind() {
			await this.$api.user.firstPhoneBind(this.phoneParams)
			this.$message.success('手机号码绑定成功，下次登录时可使用手机号码进行登录')
			await this.getUserInfoUpdate()
		},
		async updateUserInfo() {
			await this.$api.user.updateUserInfo({
				realname: this.personParams.realname,
				sex: this.personParams.sex,
				avatar: this.personParams.avatar?.node,
        login_name: this.editVisibleType == 'login' ? this.personParams.login_name : ''
			})
			await this.getUserInfoUpdate()
		},
		async getUserInfoUpdate() {
			const data = await this.$api.account.tokenGetUserInfo()
			this.$store.commit('USER_UPDATE_INFO', data)
			this.$store.commit('persist')
			this.info = { ...this.info, ...data }
			this.$message.success('个人信息更新成功')
		},
		async changeAllPhone() {
			await this.$api.user.newPhoneVerify(this.phoneParams)
			this.$message.success('手机号码更新成功，下次登录时可使用新手机号码进行登录')
			await this.getUserInfoUpdate()
		},
		async oldPhoneVerify() {
			await this.$api.user.oldPhoneVerify({ phone: this.info.mobile, ...this.identityParams })
			this.identityVisible = false
			this.editPersonVisible = true
		},
		async oldPhoneCode(_, code = '') {
      if (!code) {
        this.code.event = this.oldPhoneCode
        this.code.visible = true
        return
      }
			const data = await this.$api.user.oldPhoneCode({ phone: this.info.mobile, verify_code: code })
			this.codeLoad = !!data
			this.timer = setInterval(() => {
				if (this.time <= 0) {
					clearInterval(this.timer)
					this.time = 120
					this.codeLoad = false
				} else {
					this.time--
				}
			}, 1000)
		},
		async getPhoneCode(_, code = '') {
      if (!code) {
        this.code.event = this.getPhoneCode
        this.code.visible = true
        return
      }
			const data = await this.$api.user.newPhoneCode({ ...this.phoneParams, verify_code: code })
			this.codeLoad = !!data
			this.timer = setInterval(() => {
				if (this.time <= 0) {
					clearInterval(this.timer)
					this.time = 60
					this.codeLoad = false
				} else {
					this.time--
				}
			}, 1000)
		},
		async updateUserPass() {
			await this.$api.user.updateUserPass(this.passParams)
			this.$message.success('密码修改成功请使用新密码进行登录')
			window.localStorage.removeItem('tokenInfo')
			window.localStorage.removeItem('accountInfo')
			window.localStorage.removeItem('vuex.saved')
			window.localStorage.removeItem('vuex.menu')
      window.localStorage.removeItem('passTip')
			let url = window.location
			window.location.replace(`${url.origin}${url.pathname}`)
		},
		async fileUpload() {
			const data = await uploadFileEvent({ accept: '.jpg, .png', api: this.$api.question_set.upload })
			this.personParams.avatar = data
		}
	}
}
</script>
<style lang="scss" scoped>
.width-300 {
	width: 300px;
}
.ability-detail-header {
	display: flex;
	align-items: center;
	padding-bottom: 15px;
	background: #ffffff;
	font-size: 16px;
	cursor: pointer;
}
.ability-detail-header:hover {
	color: #ff5e2a;
}

:deep(.el-input__suffix) {
	width: 30px;
}
:deep(.el-input__suffix-inner) {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
}
:deep(.is-error) {
  margin-bottom: 40px
}
</style>
